const loginHelpOptionsTemplate = `
   <pwr-login-help-options accu="accu">
   </pwr-login-help-options> `;
export default loginHelpOptionsTemplate;
